/**
 * Copyright (C) 2018–2020 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import luiIconManager from './lui-icon-manager'
import Component from './lui-icon'
import globalCss from 'lui-icon.global.scss'
import './loader/lui-icon-path-loader'
import './loader/lui-icon-manifest-loader'

window.lui.registerComponent(Component, globalCss)

window.lui.iconManager = luiIconManager



//////////////////
// WEBPACK FOOTER
// ./packages/lui-icon/index.js
// module id = 214
// module chunks = 0 1 12